import * as React from "react";
import { cn } from "../utils/cn";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-2xl border border-brand-100/70 bg-white/85 p-8 shadow-lg shadow-brand-900/10 backdrop-blur-sm",
        className
      )}
      {...props}
    />
  )
);

Card.displayName = "Card";
